import { render } from "./ManagePatientNavigationSettingOverlay.vue?vue&type=template&id=5b2e7e2c&lang=pug"
import script from "./ManagePatientNavigationSettingOverlay.vue?vue&type=script&lang=js"
export * from "./ManagePatientNavigationSettingOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__